import React from "react";
import { useMessageSource } from "react-message-source";
import FlowStepper from "../../../../../ui/layout/page/stepper";
import { ApplicationChapterId, ApplicationFlowSteps } from "../types";
import { useFeatureToggles } from "../../../../../pages/shared/hooks/useFeatureToggles";
import { Feature } from "../../../../../context/types";
import { useCustomizedCardUploadStep } from "../useCustomizedCardUploadStep";

interface Props {
  activeChapterId: ApplicationChapterId;
}

export default function AdditionalAccountApplicationFlowStepper({
  activeChapterId,
}: Props): React.JSX.Element {
  const { getMessage } = useMessageSource();
  const canUseAttachmentUpload = useFeatureToggles(Feature.ATTACHMENT_UPLOAD);
  const hasCustomizedCard = useCustomizedCardUploadStep();

  const chapters = [
    {
      id: ApplicationChapterId.Account,
      firstStep: ApplicationFlowSteps.BASIC_ACCOUNT_INFORMATION,
      title: getMessage("BasicAccountApplicationChapter.ACCOUNT"),
    },
    {
      id: ApplicationChapterId.RegulatoryInformation,
      firstStep: ApplicationFlowSteps.REGULATORY_INFORMATION,
      title: getMessage(
        "BasicAccountApplicationChapter.REGULATORY_INFORMATION",
      ),
    },
    {
      id: ApplicationChapterId.PowerOfAttorney,
      firstStep: ApplicationFlowSteps.POWER_OF_ATTORNEY,
      title: getMessage("BasicAccountApplicationChapter.POWER_OF_ATTORNEY"),
    },
    {
      id: ApplicationChapterId.CompanyOnline,
      firstStep: ApplicationFlowSteps.COMPANY_ONLINE,
      title: getMessage("BasicAccountApplicationChapter.COMPANY_ONLINE"),
    },
    {
      id: ApplicationChapterId.Cardholder,
      firstStep: ApplicationFlowSteps.CARDHOLDER,
      title: getMessage("BasicAccountApplicationChapter.CARDHOLDER"),
    },
    {
      id: ApplicationChapterId.SignatoriesAndAppFinalization,
      firstStep: ApplicationFlowSteps.CHOOSE_SIGNATORIES,
      title: getMessage("BasicAccountApplicationChapter.SUMMARY"),
    },
  ];

  if (
    canUseAttachmentUpload &&
    activeChapterId === ApplicationChapterId.UploadAttachments
  ) {
    chapters.push({
      id: ApplicationChapterId.UploadAttachments,
      firstStep: ApplicationFlowSteps.UPLOAD_ATTACHMENTS,
      title: getMessage("BasicAccountApplicationChapter.ATTACHMENT_UPLOAD"),
    });
  } else if (
    hasCustomizedCard &&
    activeChapterId === ApplicationChapterId.UploadAttachments
  ) {
    /* If the feature attachmentUpload is disabled and the user has CustomizedCard they should be able to
    get the link for uploading a custom card */
    chapters.push({
      id: ApplicationChapterId.UploadAttachments,
      firstStep: ApplicationFlowSteps.UPLOAD_ATTACHMENTS,
      title: getMessage("BasicAccountApplicationChapter.CUSTOMIZED_CARD"),
    });
  }

  return <FlowStepper chapters={chapters} activeChapterId={activeChapterId} />;
}
